import configData from "../config/config.json";

const getTicket =  async(username, siteId) => {
    try{
        //var Buffer = require('buffer/').Buffer;
        //const authHeaderValue = "Basic " + new Buffer.from(username + ':' + password).toString('base64');
        //console.log(authHeaderValue);
        const url = configData.CCBHTableauAPIServer + '/ticket'; //'http://localhost:5000/ticket';

        const response = await fetch(url, { 
            method:"GET", 
            headers: {
                'UserID': username,
                'SiteID': siteId
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
};

export default getTicket;